import React from "react";
import { Phone, MapPin, Facebook, ArrowRight } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="tour" className="contact-bg" data-testid="contact-section">
      <div className="container-hc py-20 md:py-28">
        <div className="text-xs font-bold tracking-[0.25em] text-[color:var(--hc-coral)]">
          VISIT · CALL · CONNECT
        </div>
        <h2 className="font-serif-display mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[color:var(--hc-navy)] max-w-3xl">
          Come see what makes Hillcrest different.
        </h2>
        <p className="mt-6 text-lg text-[color:var(--hc-navy)]/75 max-w-2xl leading-relaxed">
          Stop by anytime, or give us a call and we'll set up a private tour when it's
          convenient for you. Bring your questions, your concerns, even your loved one. We'll
          put on a fresh pot of coffee.
        </p>

        <div className="mt-12 grid md:grid-cols-2 gap-4 max-w-3xl">
          <ContactCard
            icon={<Phone size={22} />}
            label="CALL"
            testId="contact-card-call"
            value={
              <a href="tel:9362750222" className="font-serif-display text-2xl text-[color:var(--hc-navy)] hover:text-[color:var(--hc-coral)] transition-colors">
                (936) 275-0222
              </a>
            }
          />
          <ContactCard
            icon={<MapPin size={22} />}
            label="VISIT"
            testId="contact-card-visit"
            value={
              <div className="font-serif-display text-xl text-[color:var(--hc-navy)] leading-tight">
                1997 Davidson Drive
                <br />
                San Augustine, Texas
              </div>
            }
          />
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 bg-[#2563a8] hover:bg-[#1d4f8a] transition-all px-7 py-3.5 rounded-full text-white font-semibold shadow-md hover:-translate-y-0.5"
            data-testid="facebook-cta"
          >
            <Facebook size={18} />
            <span>Visit Us on Facebook</span>
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

const ContactCard = ({ icon, label, value, testId }) => (
  <div className="bg-white rounded-[20px] p-6 flex gap-5 items-start border border-[color:var(--hc-navy)]/8 shadow-sm" data-testid={testId}>
    <div className="w-12 h-12 rounded-full bg-[#eaf2ec] flex items-center justify-center text-[#2d7a4f] flex-shrink-0">
      {icon}
    </div>
    <div className="flex-1">
      <div className="text-[11px] font-bold tracking-[0.22em] text-[color:var(--hc-navy)]/55">
        {label}
      </div>
      <div className="mt-1.5">{value}</div>
    </div>
  </div>
);

export default ContactSection;
